<template>
  <div class="shortcuts">
    <div class="shortcuts-grid">
      <a
        class="shortcut-card"
        v-for="item of InfoView"
        :key="item.id"
        :href="item.link"
        :target="item.target"
      >
        <div
          class="shortcut-image"
          :style="{ backgroundImage: 'url(' + item.img + ')' }"
        ></div>

        <div class="shortcut-title">
          {{ item.title }}
        </div>
      </a>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Shortcuts',
  props: {
    InfoView: Array,
  },
}
</script>